'use strict';


const MoveDir = {
    bind: function (el, binding) {
        //  Only bind once; stale listeners from a second bind are what lock the move state
        if (binding.value !== true || el.$athMove) return;

        let lastMouseY;
        let lastMouseX;

        //  Prevent traditional input tags (or anything inside them) from being used to move
        const ignoreSelector = 'button, input, a, textarea, label, select, [contenteditable]:not([contenteditable="false"])';

        //  Listen on mouse down to initialize event chain
        const onMouseDown = evt => {
            if (evt.button !== 0) return;
            if (evt.target.closest && evt.target.closest(ignoreSelector)) return;

            MeadCommon.DomUtils.preventImmediateEventEscape(evt);

            // get the mouse position at startup:
            lastMouseX = evt.clientX;
            lastMouseY = evt.clientY;

            document.addEventListener('mouseup', stop);
            document.addEventListener('mousemove', onMouseMove);
            window.addEventListener('blur', stop);
        };

        //  Listen on mouse move
        const onMouseMove = evt => {
            //  Button was released somewhere we never got a mouseup (outside window, over an iframe)
            if (evt.buttons === 0) return stop();

            evt.preventDefault();

            // Calculate new position
            const deltaY = lastMouseY - evt.clientY;
            const deltaX = lastMouseX - evt.clientX;
            lastMouseY = evt.clientY;
            lastMouseX = evt.clientX;

            if (isNaN(deltaY) || isNaN(deltaX)) return;

            //  Set new position
            el.style.top     = `${el.offsetTop - deltaY}px`;
            el.style.left    = `${el.offsetLeft - deltaX}px`;
            el.style.right   = 'initial';
            el.style.bottom  = 'initial';
            el.classList.add('ath-moved');
        };

        //  On mouse up, remove all drag listeners
        const stop = () => {
            document.removeEventListener('mouseup', stop);
            document.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('blur', stop);
            lastMouseY = undefined;
            lastMouseX = undefined;
        };

        el.addEventListener('mousedown', onMouseDown);
        el.style.cursor = 'move';
        el.$athMove = { onMouseDown, stop };
    },
    unbind: function (el) {
        el.classList.remove('ath-moved');

        if (!el.$athMove) return;

        el.$athMove.stop();
        el.removeEventListener('mousedown', el.$athMove.onMouseDown);
        el.$athMove = undefined;
        el.style.cursor = '';
    },
    update: function (el, binding) {
        //  Sync bound state with the binding value instead of rebinding on every render
        const shouldBind = binding.value === true;
        const isBound = !!el.$athMove;

        if (shouldBind && !isBound) MoveDir.bind(el, binding);
        else if (!shouldBind && isBound) MoveDir.unbind(el);
    }
};

/**
 * Adds move directive to vue. Use with `v-ath-move` or `v-mead-move`.
 * The `v-ath-move` version is deprecated; use `v-mead-move` instead.
 */
const MoveDirective = {
    bind: function (vue) {
        vue.directive('athMove', {
            bind: MoveDir.bind,
            unbind: MoveDir.unbind,
            update: MoveDir.update,
        });
        vue.directive('meadMove', {
            bind: MoveDir.bind,
            unbind: MoveDir.unbind,
            update: MoveDir.update,
        });
    },
    unbind: function (el) {
        MoveDir.unbind(el);
    }
}

export default MoveDirective;

